import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
class ToastContainer extends React.Component {
    componentWillMount() {
        if (!document) {
            return;
        }
        const { className } = this.props;
        const wrapCls = classnames('cfm_toast', `${className}`);
        // 如果是modal_toast复用原来的el，否则新生成el
        this.el = document.createElement('div');
        this.el.setAttribute('class', wrapCls);
        document.body.appendChild(this.el);
    }
    componentWillUnmount() {
        this.el && document.body.removeChild(this.el);
    }
    render() {
        const { visible } = this.props;
        if (visible) {
            setTimeout(() => {
                this.el.classList.add('cfm_toast_open');
            }, 10);
        }
        else {
            this.el.classList.remove('cfm_toast_open');
        }
        return <React.Fragment>
      {ReactDOM.createPortal(this.props.children, this.el)}
    </React.Fragment>;
    }
}
ToastContainer.defaultProps = {
    styles: {},
    visible: false,
    className: '',
};
export default ToastContainer;



// WEBPACK FOOTER //
// ./components/toast/ToastContainer.tsx